import { d as e, i as t } from "./lit-element-161a1699.js";
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const n = new WeakMap(),
  s = e((...e) => s => {
    let d = n.get(s);
    void 0 === d && (d = {
      lastRenderedIndex: 2147483647,
      values: []
    }, n.set(s, d));
    const l = d.values;
    let a = l.length;
    d.values = e;
    for (let n = 0; n < e.length && !(n > d.lastRenderedIndex); n++) {
      const o = e[n];
      if (t(o) || "function" != typeof o.then) {
        s.setValue(o), d.lastRenderedIndex = n;
        break;
      }
      n < a && o === l[n] || (d.lastRenderedIndex = 2147483647, a = 0, Promise.resolve(o).then(e => {
        const t = d.values.indexOf(o);
        t > -1 && t < d.lastRenderedIndex && (d.lastRenderedIndex = t, s.setValue(e), s.commit());
      }));
    }
  });
export { s as u };
